import React from 'react';
import { StyledHalfColText } from './StyledHalfColText';

const HalfColText = ({ children }) => {
  return (
    <React.Fragment>
      {
        <StyledHalfColText>
          {children}
        </StyledHalfColText>
      }
    </React.Fragment>
  );
};

export default HalfColText;
